module.exports = __webpack_public_path__ + "img/equip-pic4.6c747755.png";